import { calcolaDateSettimana,  } from "./resource.js"

export function popolaHistorySelect( { historyTab, selectStorico }, userPayload, callback = null){
    if( !userPayload ){ 
        historyTab.innerHTML = `<div class="text-center py-5 px-3">
                        <div class="mb-3">
                            <i class="bi bi-calendar-x text-gold opacity-75" style="font-size: 3.5rem;"></i>
                        </div>
                        <h5 class="fw-bold text-body mb-2 text-uppercase tracking-wide">Nessuna scheda disponibile nello Storico</h5>
                        <p class="text-body-secondary small mx-auto mb-0" style="max-width: 320px; line-height: 1.4;">
                            Le schede memorizzate verranno mostrate in questo spazio.
                        </p>
                        <div class="card bg-body-secondary bg-opacity-25 border-secondary-subtle shadow-sm rounded-3 overflow-hidden mt-4 mx-auto text-start" style="max-width: 400px;">
                            <div class="card-body p-3 d-flex align-items-start gap-2">
                                <i class="bi bi-info-circle text-secondary mt-0.5"></i>
                                <p class="card-text text-body-secondary small mb-0 lh-base">
                                    Se ritieni si tratti di un errore, prova a contattare direttamente il tuo tecnico o ricarica la pagina più tardi.
                                </p>
                            </div>
                        </div>
                    </div>`

        selectStorico.disabled = true
        if (callback && typeof callback === "function") callback(false);
        return;
    }

    selectStorico.innerHTML = ''
    let option = ""

    const dati = Object.entries(userPayload)
    
    dati.forEach( ([key, value], index)=>{
        const [ year, week ] = key.split('_')
        const numDay = calcolaDateSettimana( week, year )
        option += `<option value="${key}">Dal ${numDay[0]} al ${numDay[6]}</option>`
    })

    selectStorico.insertAdjacentHTML('afterbegin', option)
    selectStorico.disabled = false
    if (callback && typeof callback === "function") callback(true);
}

export function popolaHistoryUser( { historyTab }, userPayload, callback = null ){
    const { settimana, coach, nomeAtleta } = userPayload;
    const days = [ 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato', 'domenica', 'note']
    historyTab.innerHTML = ''
    const html = days.map( (day, index) => {
        const [ year, week ] = settimana.split('_')
        const numDay = calcolaDateSettimana( week, year )
        
        return `<div data-info-name="${nomeAtleta}" data-info-week="${week}" data-info-year="${year}" class="card bg-body border-secondary-subtle shadow-sm rounded-3 overflow-hidden bg-opacity-75">
                    <div data-info="${coach}" class="card-header bg-body-secondary bg-opacity-25 border-bottom border-secondary-subtle d-flex justify-content-between align-items-center px-3 py-2">
                        <span class="fw-bold text-uppercase tracking-wider small text-secondary">${day}</span>
                        <span class="text-secondary small font-monospace pdf-date-hist">${numDay[index]}</span>
                    </div>
                    <div class="card-body p-3">
                        <p class="card-text text-body-secondary mb-0 lh-base fs-6 text-pre-wrap pdf-module-hist">${userPayload[day]}</p>
                    </div>
                </div>`
    }).join('')

    historyTab.insertAdjacentHTML('afterbegin', html)
    if (callback && typeof callback === "function") callback(true);
}

/**
 * Popola dinamicamente il contenitore della scheda atleta con i dati dell'allenamento settimanale.
 * Permette il riutilizzo della stessa vista sia per la settimana corrente che per l'archivio storico.
 *
 * @param {Object} options - Oggetto contenente i nodi del DOM di destinazione.
 * @param {HTMLElement} options.currentTab - Il contenitore HTML (es. la sezione o div) in cui iniettare la scheda.
 * @param {Object|null|undefined} userPayload - I dati della scheda dell'atleta. Se assente o null, mostra la schermata di errore/vuoto.
 * @param {string} userPayload.settimana - Stringa identificativa del periodo nel formato "YYYY_WW" (es. "2026_22").
 * @param {string} userPayload.nomeAtleta - Nome completo dell'atleta.
 * @param {string} userPayload.note - Note globali o raccomandazioni inserite dal coach.
 * @param {string} userPayload.lunedi - Testo dell'allenamento per il lunedì.
 * @param {string} userPayload.martedi - Testo dell'allenamento per il martedì.
 * @param {string} userPayload.mercoledi - Testo dell'allenamento per il mercoledì.
 * @param {string} userPayload.giovedi - Testo dell'allenamento per il giovedì.
 * @param {string} userPayload.venerdi - Testo dell'allenamento per il venerdì.
 * @param {string} userPayload.sabato - Testo dell'allenamento per il sabato.
 * @param {string} userPayload.domenica - Testo dell'allenamento per la domenica.
 * @param {boolean} [history=false] - Se impostato a `true`, omette l'intestazione (header con nome e date) per l'integrazione nella vista storico.
 * @param {Function} [callback=null] - Funzione di callback opzionale eseguita al termine del rendering. 
 * Riceve `true` se la scheda è stata stampata, o `false` se l'operazione è fallita o il payload era vuoto.
 * @returns {void}
 */
export function popolaSchedaUser( { currentTab }, userPayload, callback = null ){
    if (!userPayload || !userPayload.settimana){ 
        currentTab.innerHTML = `<div class="text-center py-5 px-3">
                        <div class="mb-3">
                            <i class="bi bi-calendar-x text-gold opacity-75" style="font-size: 3.5rem;"></i>
                        </div>
                        <h5 class="fw-bold text-body mb-2 text-uppercase tracking-wide">Nessuna scheda disponibile</h5>
                        <p class="text-body-secondary small mx-auto mb-0" style="max-width: 320px; line-height: 1.4;">
                            Il tuo coach non ha ancora pubblicato il programma per questa settimana o la tua scheda è in fase di aggiornamento.
                        </p>
                        <div class="card bg-body-secondary bg-opacity-25 border-secondary-subtle shadow-sm rounded-3 overflow-hidden mt-4 mx-auto text-start" style="max-width: 400px;">
                            <div class="card-body p-3 d-flex align-items-start gap-2">
                                <i class="bi bi-info-circle text-secondary mt-0.5"></i>
                                <p class="card-text text-body-secondary small mb-0 lh-base">
                                    Se ritieni si tratti di un errore, prova a contattare direttamente il tuo tecnico o ricarica la pagina più tardi.
                                </p>
                            </div>
                        </div>
                    </div>`
        
        if (callback && typeof callback === "function") callback(false);
        return;
    }

    if (!currentTab) {
        if (callback && typeof callback === "function") callback(false);
        return;
    };

    const days = [ 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato', 'domenica']
    const { settimana, coach } = userPayload
    const [ year, week ] = settimana.split('_')

    const numDay = calcolaDateSettimana( week, year )

    const dayRowHtml = days.map( (day, index) => {
        return `<div class="card bg-body border-secondary-subtle shadow-sm rounded-3 overflow-hidden">
                <div data-info="${coach}" class="card-header bg-body-secondary bg-opacity-50 border-bottom border-secondary-subtle d-flex justify-content-between align-items-center px-3 py-2">
                    <span class="fw-bold text-uppercase tracking-wider small text-gold pdf-day">${day}</span>
                    <span class="text-secondary small font-monospace fw-medium pdf-date">${numDay[index]}</span>
                </div>
                <div class="card-body p-3">
                    <p class="card-text text-body mb-0 lh-base fs-6 text-pre-wrap pdf-module">${userPayload[day]}</p>
                </div>
            </div>`
    }).join('')    

    const html = 
        `<div class="text-center mb-3 pb-2 border-bottom border-secondary-subtle">
            <h6 class="pdf-name text-body-secondary small fw-bold text-uppercase tracking-wider mb-1" style="font-size: 0.75rem;">${userPayload.nomeAtleta}</h6>
            <h5 class="fw-bold text-body mb-1 text-uppercase tracking-wide">La tua <span class="text-gold">Scheda</span></h5>
            <p class="text-body-secondary small mb-0 font-monospace pdf-header" style="font-size: 0.8rem;">Settimana: Dal ${numDay[0]} al ${numDay[6]}</p>
        </div>
        <div class="d-flex flex-column gap-3">
            ${dayRowHtml}
            <div class="card bg-warning bg-opacity-10 border-warning border-opacity-25 shadow-sm rounded-3 overflow-hidden mt-1">
                <div class="card-header bg-warning bg-opacity-25 border-bottom border-warning border-opacity-25 px-3 py-2">
                    <span class="fw-bold text-uppercase tracking-wider small text-warning-emphasis"><i class="bi bi-sticky me-2"></i>Note del Coach</span>
                </div>
                <div class="card-body p-3">
                    <p class="card-text text-body-emphasis small mb-0 lh-base fst-italic pdf-module">${userPayload.note}</p>
                </div>
            </div>
        </div>`

    currentTab.innerHTML = ""
    currentTab.insertAdjacentHTML('afterbegin', html)
    if (callback && typeof callback === "function") callback(true);
}